import { useAppStore } from '@stores'
import useGrantedAuthScopes from '../useGrantedAuthScopes'

// The same permission the backend's superuser check reads, granted to the
// Auth0 Admin role (see useGrantedAuthScopes for how granted scopes reveal
// permissions).
const ADMIN_SCOPE = 'access:admin'

interface AdminPermissionState {
  hasAdminPermission: boolean
  isLoading: boolean
}

const useHasAdminPermission = (): AdminPermissionState => {
  const { grantedScopes, isLoading } = useGrantedAuthScopes()
  const impersonateNormalUser = useAppStore(state => state.impersonateNormalUser)

  return {
    hasAdminPermission: !impersonateNormalUser && grantedScopes.includes(ADMIN_SCOPE),
    isLoading,
  }
}

export default useHasAdminPermission
